import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AddCardIcon from "@mui/icons-material/AddCard";
import { Accordion, AccordionDetails, AccordionSummary, Chip, Typography, Paper } from "@mui/material";

import useThemeData from "@/hooks/useThemeData";
import useUserInfo from "@/hooks/useUserInfo";

const BannerCardInner = (props: { usedWhere?: "flight" }) => {
  const { usedWhere } = props;
  return (
    <div className={usedWhere === "flight" ? "flex justify-between items-center py-[20px] px-[60px] w-full" : "flex justify-between items-center mb-[10px] py-[0px] px-[60px] w-full"}>
      <Paper elevation={3} className="w-full">
        <div className="flex justify-between items-center py-[20px] px-[20px]">
          <div className="flex items-center">
            <img
              src="https://signetlondon.com/cdn/shop/products/skullquestionmark.jpg?v=1668431093"
              alt="Credit Card"
              className="w-[auto] h-[100px] mr-[10px]"
            />
            <div className="ml-[30px] text-left">
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "20px",
                }}
                color="primary"
                variant="body1"
              >
                Earn 100,000 points with a top credit card after meeting the minimum spend!
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                Best Offer of the Year! Get a top credit card we love—perfect for beginners and pros. Just meet the minimum spend and start booking amazing deals!
              </Typography>
              <Typography
                color="primary"
                sx={{
                  fontWeight: 600,
                  fontSize: "20px",
                  textDecoration: "underline",
                }}>
                Act fast—this limited-time 100,000 points offer won’t last!
              </Typography>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <Typography
              component="a"
              href="#"
              sx={{
                width: "118px",
                height: "40px",
                fontSize: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "18px",
                fontWeight: 800,
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                  textDecoration: "underline",
                }
              }}
            >
              Learn More
            </Typography>
          </div>
        </div>
      </Paper>
    </div>
  );
};

const BannerCard = (props: { measure?: () => void; usedWhere?: "flight" | "flightGrid" }) => {
  const { userInfoContext } = useUserInfo();

  const { isDarkMode } = useThemeData();

  const { measure, usedWhere } = props;

  const navigate = useNavigate();

  useEffect(() => {
    if (measure) {
      measure();
    }
  }, [measure, userInfoContext.userInfo?.token]);

  if (!userInfoContext.userInfo?.token) {
    return null;
  }

  return (
    <Accordion
      expanded={false}
      onClick={() => {
        window.open(
          "https://yourbestcreditcards.com/card-explorer/chase-sapphire-preferred-card-review/?ccid=1091",
          "_blank"
        );
      }}
      TransitionProps={{ unmountOnExit: true }}
      sx={{
        ...(usedWhere === "flight" && !isDarkMode ? {} : { boxShadow: "0" }),
        borderRadius: "0",
        // border: (theme) => `0px solid ${theme.palette.divider}`,
        textAlign: "center",
        width: "100%",
      }}
    >
      <AccordionSummary>
        <BannerCardInner usedWhere={usedWhere} />
      </AccordionSummary>

      <AccordionDetails
        // className="!pt-[15px] !pb-[20px]"
        sx={{ borderTop: (theme) => `1px solid ${theme.palette.divider}` }}
      />
    </Accordion>
  );
};

export default BannerCard;
